import { render, staticRenderFns } from "./FinalExamProtocolsIndex.vue?vue&type=template&id=975a1f8e"
import script from "./FinalExamProtocolsIndex.vue?vue&type=script&lang=js"
export * from "./FinalExamProtocolsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports